/**
 * Share dialog component.
 */
import { isMobile } from '../utils.js';

/**
 * Open the share dialog.
 *
 * @param {HTMLElement} shareDialog Share dialog element.
 * @param {HTMLElement} shareButton Share button element.
 * @param {function} outsideClickListener Outside click listener function.
 */
export function openDialog( shareDialog, shareButton, outsideClickListener ) {
	shareDialog.setAttribute( 'open', '' );

	if ( isMobile() ) {
		document.body.classList.add( 'dialog-open' );
		document.documentElement.style.overflow = 'hidden';

		setTimeout( () => shareDialog.classList.add( 'is-visible' ), 10 );
	}

	document.addEventListener( 'click', outsideClickListener );
	shareButton.setAttribute( 'aria-expanded', 'true' );
}

/**
 * Close the share dialog.
 *
 * @param {HTMLElement} shareDialog Share dialog element.
 * @param {HTMLElement} shareButton Share button element.
 * @param {function} outsideClickListener Outside click listener function.
 */
export function closeDialog( shareDialog, shareButton, outsideClickListener ) {
	if ( ! shareDialog || ! shareButton || ! outsideClickListener ) {
		return;
	}

	const copyLinkButton = document.getElementById( 'copyLinkButton' );
	if ( copyLinkButton ) {
		const shareLabel = copyLinkButton.querySelector( '.entry-meta__share-label' );
		if ( shareLabel ) {
			shareLabel.textContent = 'Copy Link';
		}

		copyLinkButton.classList.remove( 'active' );
	}

	shareButton.setAttribute( 'aria-expanded', 'false' );
	document.removeEventListener( 'click', outsideClickListener );
  
  document.body.classList.remove( 'dialog-open' );
	document.documentElement.style.overflow = '';
	shareDialog.classList.remove( 'is-visible' );

	if ( isMobile() ) {
		setTimeout(() => {
			shareDialog.removeAttribute('open');
		}, 400);
	} else {
		shareDialog.removeAttribute( 'open' );
	}
}
